import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Email} from "../../core/interfaces/admin.interface";
import {UploaderComponent} from "../uploader/uploader.component";

@Component({
    selector: 'app-email-form',
    exportAs: 'ngModel',
    templateUrl: './email-form.component.html',
    styleUrls: ['./email-form.component.scss']
})
export class EmailFormComponent implements AfterViewInit {

    @Input()
    title: string
    emailForm: FormGroup
    @ViewChild(UploaderComponent)
    uploader: UploaderComponent
    _config: EmailConfig
    uploaderHidden: boolean = false;

    constructor(private fb: FormBuilder) {
        this.emailForm = this.fb.group(
            {
                to: ['', [Validators.required, this.emailValidator]],
                bcc: ['', [this.emailValidator]],
                ccn: ['', [this.emailValidator]],
                subject: ['', [Validators.required]],
                body: ['', [Validators.required]],
            }
        );
    }

    ngAfterViewInit() {
        this.to = this._config?.to
        this.bcc = this._config?.bcc
        if(!this._config?.attachments)
            this.uploaderHidden = !this._config.attachments
    }

    get tosInvalidEmails(): boolean {
        return this.getInvalidEmailsErrors('to')
    }

    get tosInvalidEmailsMessage(): string {
        if (this.tosInvalidEmails)
            return this.getInvalidEmailsMsg('to')
        return null
    }

    get tosRequired(): boolean {
        return this.getRequiredErrors('to')
    }

    get bccInvalidEmails(): boolean {
        return this.getInvalidEmailsErrors('bcc')
    }

    get bccInvalidEmailsMessage(): string {
        if (this.bccInvalidEmails)
            return this.getInvalidEmailsMsg('bcc')
        return null
    }

    get ccnInvalidEmails(): boolean {
        return this.getInvalidEmailsErrors('ccn')
    }

    get ccnInvalidEmailsMessage(): string {
        if (this.bccInvalidEmails)
            return this.getInvalidEmailsMsg('ccn')
        return null
    }

    private getInvalidEmailsErrors(field: string) {
        return this.emailForm.get(field)?.errors?.['invalidEmails']
    }

    private getInvalidEmailsMsg(field: string) {
        return this.getInvalidEmailsErrors(field).join(', ')
    }

    get subjectRequired(): boolean {
        return this.getRequiredErrors('subject')
    }

    get bodyRequired(): boolean {
        return this.getRequiredErrors('body')
    }

    private getRequiredErrors(field: string) {
        return this.emailForm.get(field)?.errors?.['required']
    }

    emailValidator(control: AbstractControl): { [key: string]: any } | null {
        const val = control.value
        if(val == null || val.length < 1)
            return null
        const emails = val.split(';').map(email => email.trim());
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const invalidEmails = emails.filter(email => !emailPattern.test(email));
        return invalidEmails.length > 0 ? {invalidEmails: invalidEmails} : null;
    }

    public get email(): Email {
        const email = {
            to: this.emailForm.value.to?.split(';'),
            bcc: this.emailForm.value.bcc?.split(';'),
            ccn: this.emailForm.value.ccn?.split(';'),
            subject: this.emailForm.value.subject,
            body: this.emailForm.value.body,
            attachments: this.uploader.files
        }
        return email
    }

    public set to(to: string) {
        this.emailForm.controls['to'].setValue(to)
    }

    public set bcc(to: string) {
        this.emailForm.controls['bcc'].setValue(to)
    }

    set config(config: EmailConfig) {
        this._config = config
    }

    get valid():boolean {
        return this.emailForm.valid
    }
}

export interface EmailConfig {
    to?: string
    bcc?: string
    attachments: boolean
}

